import { render, staticRenderFns } from "./CaseClips.vue?vue&type=template&id=7d5ec5fd"
import script from "./CaseClips.vue?vue&type=script&lang=js"
export * from "./CaseClips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports